import { render, staticRenderFns } from "./colourConfigOther.vue?vue&type=template&id=457c6077&scoped=true"
import script from "./colourConfigOther.vue?vue&type=script&lang=js"
export * from "./colourConfigOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c6077",
  null
  
)

export default component.exports